import auth from 'app/auth/store/reducers';
import { combineReducers } from 'redux';
import fuse from './fuse';
import customerSidebarGuards from '../customerSidebarGuards';

const createReducer = asyncReducers =>
	combineReducers({
		auth,
		fuse,
		customerSidebarGuards,
		...asyncReducers
	});

export default createReducer;
